import icon from "images/icons/icon-open_new-white.svg"

export default function OpenNewTabIcon({ title }) {
  return (
    <span
      className="svg-icon"
      title={title}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}
